/* ============================================================
   Grips4Less - Grip Size Calculator
   Theme asset: assets/grip-size-guide.js   (REPLACE the whole asset)

   v2.1 adds an Inches / Centimeters toggle. All internal math stays in
   inches; cm input is converted before bucketing, and the fitting chart's
   measurement columns re-label to the chosen unit.

   Email capture runs on Omnisend's browser snippet - no API key in this file.
   Self-guarding: exits quietly on any page without #g4lCalcForm.
   ============================================================ */
(function () {
  'use strict';

  function init() {

    /* ===== Omnisend email capture config ===== */
    var OMNISEND_EVENT = 'grip size calculated';
    var SITE_ORIGIN = (window.location.protocol === 'https:' && window.location.host)
      ? window.location.protocol + '//' + window.location.host
      : 'https://www.grips4less.com';
    var OMNISEND_WAIT_MS = 4000;
    var OMNISEND_IDENTIFY_DELAY_MS = 1500;
    var RESTORE_ON_RELOAD = false;
    var G4L_DEBUG = false;

    /* ===== Units ===== */
    var DEFAULT_UNIT = 'in';        // 'in' or 'cm'
    var CM_PER_IN = 2.54;
    var unit = DEFAULT_UNIT;
    var UNIT_KEY = 'g4lGripUnit';

    function log() {
      if (!G4L_DEBUG || !window.console) { return; }
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[G4L]');
      window.console.log.apply(window.console, args);
    }

    /* ===== UTM tagging ===== */
    var UTM = { source: 'size-guide', medium: 'internal-cta', campaign: 'grip-size-guide' };
    var $ = function (id) { return document.getElementById(id); };

    function withUtm(url, content) {
      if (!url || url.charAt(0) !== '/') { return url; }
      if (url.indexOf('utm_source=') !== -1) { return url; }
      var hashAt = url.indexOf('#');
      var hash = hashAt === -1 ? '' : url.slice(hashAt);
      var base = hashAt === -1 ? url : url.slice(0, hashAt);
      var qs = 'utm_source=' + encodeURIComponent(UTM.source) +
               '&utm_medium=' + encodeURIComponent(UTM.medium) +
               '&utm_campaign=' + encodeURIComponent(UTM.campaign);
      if (content) { qs += '&utm_content=' + encodeURIComponent(content); }
      return base + (base.indexOf('?') === -1 ? '?' : '&') + qs + hash;
    }

    function tagStaticLinks() {
      var links = document.querySelectorAll('.g4l-regrip a[data-g4l-cta]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var href = a.getAttribute('href');
        if (!href) { continue; }
        a.setAttribute('href', withUtm(href, a.getAttribute('data-g4l-cta')));
      }
    }

    var form      = $('g4lCalcForm');
    var handIn    = $('g4lHand');
    var fingerIn  = $('g4lFinger');
    var handErr   = $('g4lHandErr');
    var fingerErr = $('g4lFingerErr');
    var handHint  = $('g4lHandHint');
    var fingerHint= $('g4lFingerHint');
    var resultBox = $('g4lResult');
    var sizeEl    = $('g4lSize');
    var whyEl     = $('g4lWhy');
    var flagBox   = $('g4lFlag');
    var flagText  = $('g4lFlagText');
    var kitBtn    = $('g4lShopKit');
    var allBtn    = $('g4lShopAll');
    var resetBtn  = $('g4lReset');
    var fitWrap   = $('g4lFitWrap');
    var chart     = $('g4lFitChart');
    var finalCta  = $('g4lFinalCta');
    var finalCopy = $('g4lFinalCopy');
    var unitInBtn = $('g4lUnitIn');
    var unitCmBtn = $('g4lUnitCm');

    tagStaticLinks();

    /* Smooth-scroll for in-page anchors, scoped to this guide only. */
    (function smoothAnchors() {
      var root = document.querySelector('.g4l-regrip');
      if (!root) { return; }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.addEventListener('click', function (ev) {
        var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
        if (!a || !root.contains(a)) { return; }
        var id = a.getAttribute('href').slice(1);
        if (!id) { return; }
        var dest = document.getElementById(id);
        if (!dest) { return; }
        ev.preventDefault();
        dest.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + id);
        }
      });
    }());

    if (!form) { return; }

    /* ===== Size definitions ===== */
    var SIZES = {
      undersize: { label: 'Undersize', cls: 'u', kit: '/collections/golf-grip-kits/undersize', all: '/collections/undersize-golf-grips', why: 'Smaller hands fit an undersize grip, which lets the hands release more freely through impact.' },
      standard:  { label: 'Standard',  cls: 's', kit: '/collections/golf-grip-kits/standard',  all: '/collections/standard-size-golf-grips', why: 'Standard is the baseline size most clubs ship with, and it suits the widest range of hands.' },
      midsize:   { label: 'Midsize',   cls: 'm', kit: '/collections/golf-grip-kits/midsize',   all: '/collections/midsize-golf-grips', why: 'Larger hands fit a midsize grip, which quiets the hands and reduces wrist action.' },
      oversize:  { label: 'Jumbo / Oversize', cls: 'o', kit: '/collections/golf-grip-kits/oversize', all: '/collections/oversize-jumbo-golf-grips', why: 'The largest hands fit a jumbo grip, which quiets overactive hands and eases pressure on the fingers.' }
    };

    /* Bucket boundaries in INCHES. Lower bound inclusive, upper exclusive. */
    var HAND_BOUNDS   = [5.75, 6.5, 7, 7.75, 8.25, 8.75, 9.25];
    var FINGER_BOUNDS = [3, 4];

    var GRID = [
      ['undersize', 'undersize', 'undersize'],
      ['undersize', 'standard',  'standard' ],
      ['standard',  'standard',  'standard' ],
      ['standard',  'midsize',   'midsize'  ],
      ['standard',  'midsize',   'midsize'  ],
      ['midsize',   'midsize',   'midsize'  ],
      ['midsize',   'oversize',  'oversize' ],
      ['midsize',   'oversize',  'oversize' ]
    ];

    /* Validation range in INCHES */
    var HAND_MIN = 4, HAND_MAX = 13, FINGER_MIN = 1.5, FINGER_MAX = 7;

    /* ===== Unit helpers ===== */
    function toInches(v)   { return unit === 'cm' ? v / CM_PER_IN : v; }
    function fromInches(v) { return unit === 'cm' ? v * CM_PER_IN : v; }
    function unitWord()    { return unit === 'cm' ? 'cm' : 'inches'; }
    function unitMark()    { return unit === 'cm' ? ' cm' : '"'; }
    function egString()    { return unit === 'cm' ? 'for example 19 or 19.1' : 'for example 7.5 or 7 1/2'; }
    function egFinger()    { return unit === 'cm' ? 'for example 8 or 8.5'   : 'for example 3.25 or 3 1/4'; }

    function fmt1(n) {
      var r = Math.round(n * 10) / 10;
      return String(r).replace(/\.0$/, '');
    }

    /* ===== Input parsing: accepts 7.5, 7 1/2, 7-1/2, 7½, 15/2, 19, 19.1 ===== */
    var VULGAR = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875 };

    function parseMeasure(raw) {
      if (raw == null) { return NaN; }
      var s = String(raw).trim().toLowerCase();
      if (!s) { return NaN; }
      s = s.replace(/centimeters|centimeter|inches|inch|\bcm\b|in\b|["”“'′″]/g, ' ').trim();
      s = s.replace(/[¼½¾⅓⅔⅛⅜⅝⅞]/g, function (m) { return ' ' + VULGAR[m]; });
      s = s.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      var mixed = s.match(/^(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
      if (mixed) { var d1 = parseFloat(mixed[3]); if (!d1) { return NaN; } return parseFloat(mixed[1]) + parseFloat(mixed[2]) / d1; }
      var frac = s.match(/^(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
      if (frac) { var d2 = parseFloat(frac[2]); if (!d2) { return NaN; } return parseFloat(frac[1]) / d2; }
      var sum = s.match(/^(\d+(?:\.\d+)?)\s+(0?\.\d+)$/);
      if (sum) { return parseFloat(sum[1]) + parseFloat(sum[2]); }
      var plain = s.match(/^(\d+(?:\.\d+)?)$/);
      if (plain) { return parseFloat(plain[1]); }
      return NaN;
    }

    function bucket(value, bounds) {
      for (var i = 0; i < bounds.length; i++) { if (value < bounds[i]) { return i; } }
      return bounds.length;
    }

    function setError(input, el, message) {
      if (message) {
        el.textContent = message; el.hidden = false;
        input.classList.add('is-invalid'); input.setAttribute('aria-invalid', 'true');
      } else {
        el.textContent = ''; el.hidden = true;
        input.classList.remove('is-invalid'); input.removeAttribute('aria-invalid');
      }
    }

    /* ===== Chart re-labelling ===== */
    /* Cache the original inch cell text so switching back to inches keeps the
       nice fraction display (e.g. 5 3/4"). cm labels are generated numerically. */
    function cacheChartOriginals() {
      if (!chart) { return; }
      var rows = chart.querySelectorAll('tbody tr[data-hand]');
      for (var i = 0; i < rows.length; i++) {
        var cells = rows[i].getElementsByTagName('td');
        if (cells.length < 2) { continue; }
        if (!rows[i].getAttribute('data-orig-hand'))   { rows[i].setAttribute('data-orig-hand', cells[0].innerHTML); }
        if (!rows[i].getAttribute('data-orig-finger')) { rows[i].setAttribute('data-orig-finger', cells[1].innerHTML); }
      }
    }

    function rangeLabel(idx, bounds) {
      function disp(inVal) { return fmt1(unit === 'cm' ? inVal * CM_PER_IN : inVal); }
      var u = unitMark();
      if (idx === 0) { return 'Under ' + disp(bounds[0]) + u; }
      if (idx === bounds.length) { return disp(bounds[bounds.length - 1]) + u + ' and over'; }
      return disp(bounds[idx - 1]) + u + '–' + disp(bounds[idx]) + u; // en-dash range
    }

    function applyUnitToChart() {
      if (!chart) { return; }
      var rows = chart.querySelectorAll('tbody tr[data-hand]');
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        var cells = r.getElementsByTagName('td');
        if (cells.length < 2) { continue; }
        var h = parseInt(r.getAttribute('data-hand'), 10);
        var f = parseInt(r.getAttribute('data-finger'), 10);
        if (unit === 'cm') {
          cells[0].textContent = rangeLabel(h, HAND_BOUNDS);
          cells[1].textContent = rangeLabel(f, FINGER_BOUNDS);
        } else {
          cells[0].innerHTML = r.getAttribute('data-orig-hand') || cells[0].innerHTML;
          cells[1].innerHTML = r.getAttribute('data-orig-finger') || cells[1].innerHTML;
        }
      }
      // update the header labels' unit hint
      var ths = chart.querySelectorAll('thead th');
      if (ths.length >= 2) {
        ths[0].textContent = 'Full Hand Length (' + (unit === 'cm' ? 'cm' : 'in') + ')';
        ths[1].textContent = 'Longest Finger Length (' + (unit === 'cm' ? 'cm' : 'in') + ')';
      }
    }

    /* Update input suffixes, placeholders, hints for the current unit */
    function applyUnitToInputs() {
      var suffixes = document.querySelectorAll('.g4l-regrip .calc__unit');
      for (var i = 0; i < suffixes.length; i++) { suffixes[i].textContent = unitWord(); }
      if (unit === 'cm') {
        handIn.setAttribute('placeholder', '19');
        fingerIn.setAttribute('placeholder', '8');
      } else {
        handIn.setAttribute('placeholder', '7 1/2');
        fingerIn.setAttribute('placeholder', '3 1/4');
      }
    }

    function setUnitButtons() {
      if (unitInBtn) {
        unitInBtn.classList.toggle('is-active', unit === 'in');
        unitInBtn.setAttribute('aria-pressed', unit === 'in' ? 'true' : 'false');
      }
      if (unitCmBtn) {
        unitCmBtn.classList.toggle('is-active', unit === 'cm');
        unitCmBtn.setAttribute('aria-pressed', unit === 'cm' ? 'true' : 'false');
      }
    }

    /* Switch unit: convert any typed values, re-label chart + inputs, persist */
    function setUnit(next) {
      if (next === unit) { return; }
      var oldUnit = unit;
      // convert current field values so the same physical measurement is kept
      [handIn, fingerIn].forEach(function (inp) {
        var raw = (inp.value || '').trim();
        if (!raw) { return; }
        var v = parseMeasure(raw);
        if (isNaN(v)) { return; }
        var inches = (oldUnit === 'cm') ? v / CM_PER_IN : v;
        inp.value = fmt1(next === 'cm' ? inches * CM_PER_IN : inches);
      });
      unit = next;
      try { window.sessionStorage.setItem(UNIT_KEY, unit); } catch (e) {}
      setUnitButtons();
      applyUnitToInputs();
      applyUnitToChart();
      // clear any stale validation messages (bounds text changes with unit)
      setError(handIn, handErr, '');
      setError(fingerIn, fingerErr, '');
    }

    if (unitInBtn) { unitInBtn.addEventListener('click', function () { setUnit('in'); }); }
    if (unitCmBtn) { unitCmBtn.addEventListener('click', function () { setUnit('cm'); }); }

    /* ===== Chart row highlighting ===== */
    function clearHighlight() {
      if (!chart) { return; }
      var marked = chart.querySelectorAll('.is-match');
      for (var i = 0; i < marked.length; i++) { marked[i].classList.remove('is-match'); }
    }
    function highlightRow(handIdx, fingerIdx) {
      if (!chart) { return; }
      clearHighlight();
      var row = chart.querySelector('tr[data-hand="' + handIdx + '"][data-finger="' + fingerIdx + '"]');
      if (row) { row.classList.add('is-match'); return; }
      var cells = chart.children;
      var start = 3 + (handIdx * 3 + fingerIdx) * 3;
      for (var j = start; j < start + 3 && j < cells.length; j++) {
        if (cells[j].classList) { cells[j].classList.add('is-match'); }
      }
    }

    /* ===== Borderline nudge (measurements are in INCHES here) ===== */
    function borderlineNote(hand, finger) {
      var TOL = 0.15, i;
      for (i = 0; i < HAND_BOUNDS.length; i++) {
        if (Math.abs(hand - HAND_BOUNDS[i]) <= TOL) {
          return 'Your hand length sits right on a boundary in the chart. If you grip the club tightly, fight a hook, or feel hand or wrist strain, size up. If you want a freer release, size down.';
        }
      }
      for (i = 0; i < FINGER_BOUNDS.length; i++) {
        if (Math.abs(finger - FINGER_BOUNDS[i]) <= TOL) {
          return 'Your finger length sits right on a boundary in the chart. Build-up tape under a standard grip can fine-tune the installed size in small increments if you land between two options.';
        }
      }
      return '';
    }

    /* ===== State persistence (stores INCHES) ===== */
    var STORE_KEY = 'g4lGripSize';
    function saveState(state) { try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }
    function readState() { try { var raw = window.sessionStorage.getItem(STORE_KEY); return raw ? JSON.parse(raw) : null; } catch (e) { return null; } }
    function clearState() { try { window.sessionStorage.removeItem(STORE_KEY); } catch (e) {} }

    function markPicked(key) {
      var root = document.querySelector('.g4l-regrip');
      var nodes = document.querySelectorAll('.g4l-regrip [data-g4l-size]');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (key && n.getAttribute('data-g4l-size') === key) { n.classList.add('is-picked'); }
        else { n.classList.remove('is-picked'); }
      }
      if (root) { if (key) { root.classList.add('has-pick'); } else { root.classList.remove('has-pick'); } }
    }

    function updateFinalCta(key) {
      if (!finalCta) { return; }
      var s = SIZES[key];
      if (!s) { return; }
      finalCta.textContent = 'Shop your ' + s.label + ' grip kits';
      finalCta.setAttribute('href', withUtm(s.kit, 'footer-' + key + '-kit'));
      if (finalCopy) {
        finalCopy.textContent = 'Based on your measurements you fit a ' + s.label +
          ' grip. Grab a full 13-piece kit with the tape and tools included, or learn how to do the job yourself.';
      }
    }

    function track(name, props) {
      try { if (window.posthog && window.posthog.capture) { window.posthog.capture(name, props); } } catch (e) {}
      try { if (window.dataLayer && window.dataLayer.push) { window.dataLayer.push(Object.assign({ event: name }, props)); } } catch (e) {}
    }

    /* ===== Render (hand/finger are INCHES) ===== */
    var current = null;
    function render(key, hand, finger, handIdx, fingerIdx, opts) {
      var s = SIZES[key];
      current = { key: key, hand: hand, finger: finger };
      sizeEl.textContent = s.label;
      sizeEl.className = 'calc__size calc__size--' + s.cls;
      whyEl.textContent = s.why;

      var note = borderlineNote(hand, finger);
      if (note) { flagText.textContent = note; flagBox.hidden = false; }
      else { flagBox.hidden = true; }

      kitBtn.textContent = 'Shop ' + s.label + ' grip kits';
      kitBtn.setAttribute('href', withUtm(s.kit, 'calc-' + key + '-kit'));
      allBtn.textContent = 'Browse all ' + s.label + ' grips';
      allBtn.setAttribute('href', withUtm(s.all, 'calc-' + key + '-all'));

      resultBox.hidden = false;
      if (resetBtn) { resetBtn.hidden = false; }
      if (fitWrap) { fitWrap.classList.add('has-result'); }

      highlightRow(handIdx, fingerIdx);
      markPicked(key);
      updateFinalCta(key);
      saveState({ key: key, hand: hand, finger: finger });

      if (!opts || !opts.silent) {
        track('grip_size_calculated', { grip_size: s.label, hand_length_in: hand, finger_length_in: finger, entry_unit: unit });
        if (typeof resultBox.scrollIntoView === 'function') { resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      }
    }

    /* ===== Submit ===== */
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();

      var handRaw = parseMeasure(handIn.value);
      var fingerRaw = parseMeasure(fingerIn.value);
      var hand = isNaN(handRaw) ? NaN : toInches(handRaw);
      var finger = isNaN(fingerRaw) ? NaN : toInches(fingerRaw);
      var ok = true;
      var u = unitMark().trim() || 'in';
      function b(inVal) { return fmt1(fromInches(inVal)); }

      if (isNaN(hand)) {
        setError(handIn, handErr, 'Enter a number, ' + egString() + '.'); ok = false;
      } else if (hand < HAND_MIN || hand > HAND_MAX) {
        setError(handIn, handErr, 'Hand length should be between ' + b(HAND_MIN) + u + ' and ' + b(HAND_MAX) + u + '. Double-check your tape measure.'); ok = false;
      } else { setError(handIn, handErr, ''); }

      if (isNaN(finger)) {
        setError(fingerIn, fingerErr, 'Enter a number, ' + egFinger() + '.'); ok = false;
      } else if (finger < FINGER_MIN || finger > FINGER_MAX) {
        setError(fingerIn, fingerErr, 'Finger length should be between ' + b(FINGER_MIN) + u + ' and ' + b(FINGER_MAX) + u + '. Double-check your tape measure.'); ok = false;
      } else if (!isNaN(hand) && finger >= hand) {
        setError(fingerIn, fingerErr, 'Finger length should be shorter than full hand length.'); ok = false;
      } else { setError(fingerIn, fingerErr, ''); }

      if (!ok) { var bad = form.querySelector('.is-invalid'); if (bad) { bad.focus(); } return; }

      var hIdx = bucket(hand, HAND_BOUNDS);
      var fIdx = bucket(finger, FINGER_BOUNDS);
      render(GRID[hIdx][fIdx], hand, finger, hIdx, fIdx);
    });

    /* ===== Reset ===== */
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        handIn.value = ''; fingerIn.value = '';
        setError(handIn, handErr, ''); setError(fingerIn, fingerErr, '');
        resultBox.hidden = true; resetBtn.hidden = true; current = null;
        if (fitWrap) { fitWrap.classList.remove('has-result'); }
        clearHighlight(); markPicked(null);
        if (finalCta) {
          finalCta.textContent = 'Shop all golf grips';
          finalCta.setAttribute('href', withUtm('/collections/golf-grips', 'footer-all-grips'));
        }
        if (finalCopy) { finalCopy.textContent = 'Browse the full lineup across every size and brand, or learn how to do the job yourself.'; }
        clearState(); handIn.focus();
      });
    }

    /* ===== Omnisend email capture ===== */
    var emailToggle = $('g4lEmailToggle');
    var emailForm   = $('g4lEmailForm');
    var emailIn     = $('g4lEmail');
    var emailMsg    = $('g4lEmailMsg');
    var emailOk     = $('g4lEmailOk');
    var emailSubmit = $('g4lEmailSubmit');
    var emailWrap   = $('g4lEmailWrap');

    function whenOmnisendReady(cb) {
      var waited = 0, STEP = 200, LIMIT = OMNISEND_WAIT_MS;
      (function poll() {
        if (window.omnisend && typeof window.omnisend.identifyContact === 'function') { return cb(true); }
        waited += STEP;
        if (waited >= LIMIT) { return cb(false); }
        window.setTimeout(poll, STEP);
      }());
    }

    if (emailForm) {
      if (emailWrap) { emailWrap.style.display = 'none'; }
      whenOmnisendReady(function (ready) {
        if (!ready) { log('Omnisend snippet NOT found - email box stays hidden.'); return; }
        if (emailWrap) { emailWrap.style.display = ''; }
        if (emailToggle) {
          emailToggle.addEventListener('click', function () {
            var open = emailForm.hidden; emailForm.hidden = !open;
            emailToggle.setAttribute('aria-expanded', String(open));
            if (open && emailIn) { emailIn.focus(); }
          });
        }
        emailForm.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var value = (emailIn.value || '').trim();
          var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
          if (!valid) {
            emailIn.classList.add('is-invalid'); emailMsg.textContent = 'Enter a valid email address.';
            emailMsg.classList.add('is-error'); emailIn.focus(); return;
          }
          emailIn.classList.remove('is-invalid'); emailMsg.classList.remove('is-error');
          emailMsg.textContent = 'Sending…'; emailSubmit.disabled = true;
          var sizeLabel = current ? SIZES[current.key].label : '';
          var settled = false;
          function succeed() {
            if (settled) { return; } settled = true;
            emailForm.hidden = true;
            if (emailToggle) { emailToggle.hidden = true; }
            var head = emailWrap ? emailWrap.querySelector('.calc__email-head') : null;
            if (head) { head.hidden = true; }
            emailOk.hidden = false;
            track('grip_size_email_captured', { grip_size: sizeLabel });
          }
          function fail() {
            if (settled) { return; } settled = true;
            emailMsg.textContent = 'Something went wrong. Please try again, or shop your size using the buttons above.';
            emailMsg.classList.add('is-error'); emailSubmit.disabled = false;
          }
          var payload = {
            origin: 'api',
            properties: {
              gripSize:           sizeLabel,
              handLengthInches:   current ? String(current.hand) : '',
              fingerLengthInches: current ? String(current.finger) : '',
              entryUnit:          unit,
              shopKitUrl:         current ? SITE_ORIGIN + SIZES[current.key].kit : '',
              shopAllUrl:         current ? SITE_ORIGIN + SIZES[current.key].all : '',
              source:             'what-size-grip-do-i-need calculator',
              pageUrl:            String(window.location.href)
            },
            callbacks: {
              onSuccess: function () { succeed(); },
              onError:   function () { fail(); }
            }
          };
          try {
            window.omnisend.identifyContact({ email: value });
            window.setTimeout(function () {
              try {
                window.omnisend.push(['track', OMNISEND_EVENT, payload]);
                window.setTimeout(succeed, 2000);
              } catch (inner) { fail(); }
            }, OMNISEND_IDENTIFY_DELAY_MS);
          } catch (e) { fail(); }
        });
      });
    }

    /* ===== Initial unit + chart setup ===== */
    cacheChartOriginals();
    (function initialUnit() {
      var saved = '';
      try { saved = (window.sessionStorage.getItem(UNIT_KEY) || '').toLowerCase(); } catch (e) {}
      unit = (saved === 'cm') ? 'cm' : DEFAULT_UNIT;
      setUnitButtons();
      applyUnitToInputs();
      applyUnitToChart();
    }());

    /* ===== Page load: reset by default ===== */
    (function initialState() {
      var param = '';
      try { param = (new URLSearchParams(window.location.search).get('size') || '').toLowerCase().trim(); } catch (e) {}
      if (param === 'jumbo' || param === 'oversized') { param = 'oversize'; }

      if (!RESTORE_ON_RELOAD) {
        clearState(); handIn.value = ''; fingerIn.value = '';
        if (SIZES[param]) { updateFinalCta(param); }
        return;
      }
      var saved = readState();
      if (saved && SIZES[saved.key] && typeof saved.hand === 'number' && typeof saved.finger === 'number') {
        // stored values are inches; show them in the current unit
        handIn.value = fmt1(fromInches(saved.hand));
        fingerIn.value = fmt1(fromInches(saved.finger));
        var hIdx = bucket(saved.hand, HAND_BOUNDS);
        var fIdx = bucket(saved.finger, FINGER_BOUNDS);
        render(GRID[hIdx][fIdx], saved.hand, saved.finger, hIdx, fIdx, { silent: true });
        return;
      }
      if (SIZES[param]) { updateFinalCta(param); }
    }());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());